export default function FilterGroup({ label, children }) {
	return (
		<div>
			<label className="block text-xs font-semibold text-[#666055] uppercase tracking-wider mb-2">{label}</label>
			{children}
		</div>
	);
}